import React from 'react';
import { useLayout } from '../../../../context/LayoutContext';
import { useTickets } from '../../../../context/TicketsContext';

const TicketDetailModal = () => {
  const { theme } = useLayout();
  const { selectedTicket, setIsDetailModalOpen } = useTickets();

  if (!selectedTicket) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusLabel = (status) => {
    const statusMap = {
      'reportados': 'Reportado',
      'en-proceso': 'En proceso',
      'en-prueba': 'En prueba',
      'finalizado': 'Finalizado',
      'reabiertos': 'Reabierto'
    };
    return statusMap[status] || status;
  };

  const getPriorityLabel = (priority) => {
    const priorityMap = {
      'low': 'Baja',
      'medium': 'Media',
      'high': 'Alta',
      'critical': 'Crítica'
    };
    return priorityMap[priority] || priority;
  };

  const getStatusClass = (status) => {
    const statusMap = {
      'reportados': 'status-open',
      'en-proceso': 'status-progress',
      'en-prueba': 'status-testing',
      'finalizado': 'status-resolved',
      'reabiertos': 'status-reopened'
    };
    return statusMap[status] || 'status-open';
  };

  const getPriorityClass = (priority) => {
    const priorityMap = {
      'low': 'priority-low',
      'medium': 'priority-medium',
      'high': 'priority-high',
      'critical': 'priority-critical'
    };
    return priorityMap[priority] || 'priority-medium';
  };

  return (
    <div 
      className={`GM__${theme}-modal-overlay`}
      onClick={() => setIsDetailModalOpen(false)}
    >
      <div 
        className={`GM__${theme}-modal-content GM__${theme}-modal-large`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`GM__${theme}-modal-header`}>
          <div className={`GM__${theme}-ticket-detail-header`}>
            <h2>{selectedTicket.id} - {selectedTicket.title}</h2>
            <div className={`GM__${theme}-ticket-badges`}>
              <span className={`GM__${theme}-status-badge ${getStatusClass(selectedTicket.status)}`}>
                {getStatusLabel(selectedTicket.status)}
              </span>
              <span className={`GM__${theme}-priority-badge ${getPriorityClass(selectedTicket.priority)}`}>
                {getPriorityLabel(selectedTicket.priority)}
              </span>
            </div>
          </div>
          <button 
            className={`GM__${theme}-modal-close`}
            onClick={() => setIsDetailModalOpen(false)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className={`GM__${theme}-ticket-detail-content`}>
          <div className={`GM__${theme}-detail-section`}>
            <h3>Descripción</h3>
            <p>{selectedTicket.description}</p>
          </div>

          <div className={`GM__${theme}-detail-meta`}>
            <div className={`GM__${theme}-meta-grid`}>
              <div className={`GM__${theme}-meta-item`}>
                <span className={`GM__${theme}-meta-label`}>Reportado por:</span>
                <span className={`GM__${theme}-meta-value`}>{selectedTicket.reporter}</span>
              </div>
              <div className={`GM__${theme}-meta-item`}>
                <span className={`GM__${theme}-meta-label`}>Asignado a:</span>
                <span className={`GM__${theme}-meta-value`}>{selectedTicket.assignee || 'Sin asignar'}</span>
              </div>
              <div className={`GM__${theme}-meta-item`}>
                <span className={`GM__${theme}-meta-label`}>Creado:</span>
                <span className={`GM__${theme}-meta-value`}>{formatDate(selectedTicket.created)}</span>
              </div>
              <div className={`GM__${theme}-meta-item`}>
                <span className={`GM__${theme}-meta-label`}>Actualizado:</span>
                <span className={`GM__${theme}-meta-value`}>{formatDate(selectedTicket.updated)}</span>
              </div>
            </div>
          </div>

          {selectedTicket.comments && selectedTicket.comments.length > 0 && (
            <div className={`GM__${theme}-detail-section`}>
              <h3>Comentarios</h3>
              <div className={`GM__${theme}-comments-list`}>
                {selectedTicket.comments.map(comment => (
                  <div key={comment.id} className={`GM__${theme}-comment-item`}>
                    <div className={`GM__${theme}-comment-header`}>
                      <span className={`GM__${theme}-comment-author`}>{comment.author}</span>
                      <span className={`GM__${theme}-comment-time`}>{formatDate(comment.timestamp)}</span>
                    </div>
                    <div className={`GM__${theme}-comment-content`}>{comment.content}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Sección para agregar comentarios */}
          <div className={`GM__${theme}-detail-section`}>
            <h3>Añadir comentario</h3>
            <div className={`GM__${theme}-add-comment-form`}>
              <textarea
                className={`GM__${theme}-form-textarea`}
                placeholder="Escribe tu comentario aquí..."
                rows="3"
              ></textarea>
              <div className={`GM__${theme}-form-actions`}>
                <button className={`GM__${theme}-btn-primary`}>
                  Enviar comentario
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketDetailModal;